const title = process.env.VUE_APP_TITLE
const getTitle = function(til) {
  let allTitle = til + ' - ' + title
  return allTitle
}
export default getTitle
